import { gql, TypedDocumentNode } from "@apollo/client";

import { Role } from "types/generated";

type UserRoleData = {
  roles: Role[];
};

export const USER_ROLES_FOR_GROUP_MAPPING: TypedDocumentNode<UserRoleData> = gql`
  query UserRolesForGroupMapping {
    roles {
      id
      name
    }
  }
`;
